<div class="agpr-formField agpr-multiMetricsPicker" role="group" [attr.aria-labelledby]="field.headingId" [attr.aria-describedby]="id + '_hint'">
    <span [id]="id + '_hint'" class="agpr-multiMetricsPicker-limitMessage">
        {{ 'Reports.multiMetricsPicker.selectUpTo' | localize: {number: maxNumberOfMetrics} }}
    </span>
    <ol>
        <li
            *ngFor="let metricOption of selectedMetricsOptions; index as index"
            class="agpr-multiMetricsPicker-container"
        >
            <div class="agpr-multiMetricsPicker-labelContainer">
                <span class="agpr-multiMetricsPicker-labelContainer-label">
                    {{ 'Reports.multiMetricsPicker.labelWithNumber' | localize: {number: index + 1} }}
                </span>
                <agpr-button
                    *ngIf="selectedMetrics.length > 1"
                    class="agpr-multiMetricsPicker-labelContainer-deleteButton"
                    [id]="id + '_deleteMetric'"
                    icon="fa-regular fa-duotone fa-trash-can"
                    tooltip="Reports.multiMetricsPicker.removeMetric"
                    [ariaLabel]="('Reports.multiMetricsPicker.removeMetric' | localize) + ' ' + (index + 1)"
                    (click)="deleteMetric(index)"
                    [style]="buttonTypes.icon"
                ></agpr-button>
            </div>
            <agpr-dropdown
                [id]="'picker_' + index"
                [options]="metricOption.options"
                [ngModel]="metricOption.selection"
                (ngModelChange)="onDropdownChanged($event.value, index)"
                [ariaLabel]="'Reports.multiMetricsPicker.labelWithNumber' | localize: {'number': index + 1}"
            ></agpr-dropdown>
        </li>
    </ol>

    <div class="agpr-multiMetricsPicker-addMetricContainer">
        <agpr-button
            class="agpr-multiMetricsPicker-addMetricButton"
            (click)="addMetric()"
            [style]="buttonTypes.tertiary"
            [id]="id + '.addMetricButton'"
            label="Reports.multiMetricsPicker.addMetric"
            [disabled]="selectedMetrics && selectedMetrics.length >= maxNumberOfMetrics">
        </agpr-button>
    </div>
</div>
